// extracted by mini-css-extract-plugin
module.exports = {"info":"e2ff468f85--info--2lTFs"};